import { useMediaQuery } from "@mui/material";
import { Share } from "../../components";
import style from "./block.module.scss";
import { defineBlock } from "@smartfire/js-block-engine";

function Block({ mobile, title, image, date, author, readingTime }) {
  const isDesktop = useMediaQuery("(min-width:" + style.tabletBreakpoint + ")");
  const isDesktop_XOR_mobile = (!mobile && isDesktop) || (mobile && !isDesktop);

  // Tricky but needed because share bloc completly change of position in mobile
  return !isDesktop_XOR_mobile ? null : (
    <div className={style.block}>
      <Share
        name={author}
        date={date}
        isDesktop={isDesktop}
        time={readingTime}
        imageurl={image}
        titlePost={title}
      />
    </div>
  );
}

export default defineBlock({
  Block: Block,
});
